import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAsWoBsCFgQWmGshvRnd-D_nM6pqhoeiwA",
  authDomain: "uniq-core.firebaseapp.com",
  databaseURL: "https://uniq-core.firebaseio.com",
  projectId: "uniq-core",
  storageBucket: "uniq-core.firebasestorage.app",
  messagingSenderId: "129617012485",
  appId: "1:129617012485:web:b153c8d5cf7210c4d7396c",
  measurementId: "G-LV75N8N0RD",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Return a messaging instance only when the browser actually supports it.
// Calling getMessaging() eagerly on unsupported browsers (e.g. iOS Safari tabs)
// triggers an unhandled `messaging/unsupported-browser` rejection, so gate it
// behind the async isSupported() check instead.
export async function getMessagingIfSupported() {
  return (await isSupported()) ? getMessaging(app) : null;
}

export { app, getToken, onMessage };
